import React from 'react';
import PropTypes from 'prop-types';

import JBImage from 'components/essentials/JBImage';
import CollectionsGridMobilePlaceholders from './CollectionsGridMobilePlaceholders';

const CollectionsGridMobile = ({
  collections,
  loading,
  setSelectedCollection,
}) => (
  <div className="md:hidden">
    {loading ? (
      <CollectionsGridMobilePlaceholders />
    ) : (
      collections.map(
        collection =>
          collection.images[0] && (
            <button
              className="text-left"
              key={collection.id}
              onClick={() => setSelectedCollection(collection)}
              type="button"
            >
              <JBImage
                src={collection.images[0].url}
                alt=""
                sizes="100vw"
                ar="1:1"
              />

              <div className="mx-0 my-8 px-4 py-0">
                <h4 className="text-sm font-bold mb-[.325rem] text-gray">
                  {collection.name}
                </h4>

                <div className="text-xs text-gray">
                  {collection.category_description ||
                    collection.category_meta_description}
                </div>
              </div>
            </button>
          )
      )
    )}
  </div>
);

CollectionsGridMobile.propTypes = {
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      category_description: PropTypes.string,
      category_meta_description: PropTypes.string,
      images: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  loading: PropTypes.bool,
  setSelectedCollection: PropTypes.func,
};

export default CollectionsGridMobile;
